import React from 'react'

import Social from '../Social'
import Title from '../Title'
import * as S from './styled'

const Footer = () => (
  <S.FooterWrapper>
    <Title appearance="tiny" color="light" marginBottom={16}>
      Conheça o Grupo Roccia: <S.FooterBreak />
      <S.FooterLink
        title="somosroccia.com.br"
        href="https://somosroccia.com.br"
        target="_blank"
      >
        somosroccia.com.br
      </S.FooterLink>
    </Title>
    <Social />
  </S.FooterWrapper>
)

export default Footer
